<template>
    <div class="glass-theme fade-in-page">
        <b-card :style="{'max-width': '100%', 'width': '100%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}" class="glass-card">
            <!-- API Loading Overlay with Animation - Fixed height version -->
            <transition name="loading-overlay">
                <div v-if="apiLoading" class="loading-overlay">
                    <div class="loading-card loading-card-fixed">
                        <div class="loading-animation">
                            <div class="loading-ring">
                                <div class="ring"></div>
                                <div class="ring"></div>
                                <div class="ring"></div>
                                <div class="loading-logo">
                                    <i class="fas fa-dollar-sign"></i>
                                </div>
                            </div>
                        </div>
                        <div class="loading-text">
                            <h3>{{ loadingMessage }}</h3>
                            <div class="loading-dots">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </div>
                        </div>
                        <div class="loading-progress">
                            <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                        </div>
                        <div class="loading-tips loading-tips-fixed">
                            <p class="tip-text">{{ currentTip }}</p>
                        </div>
                    </div>
                </div>
            </transition>

            <b-card-text>
                <h4>REFUND REQUESTS</h4>
                <b-alert variant="secondary" show class="glass-alert"><sub>This tool showcases all the invoices on which refunds are requested.</sub></b-alert>
            </b-card-text>

            <div>
                <button @click="fetch_init" class="glass-btn" :disabled="apiLoading">
                    <span v-if="apiLoading" class="spinner-sm"></span>
                    <span v-else>🔄</span> RELOAD
                </button>
            </div>

            <div>
                <div v-if="items_being_loaded == true && !apiLoading">
                    <loading :active="items_being_loaded"
                        :can-cancel="false"
                        :is-full-page="true">
                    </loading>
                </div>
                <div v-else>
                    <div v-if="items.length == 0">
                        <b-alert variant="primary" show class="glass-alert">NO REFUND REQUESTS YET</b-alert>
                    </div>
                    <div v-else style="overflow-x: auto; width: 100%;">
                        <table class="text-monospace" style="width: 100%; margin-top: 10px;">
                            <thead>
                                <tr style="background: linear-gradient(135deg, #1e293b, #0f172a); color: white;">
                                    <th style="min-width: 100px;" class="ipt_tdhr" v-on:click="sortby('ts')">
                                        REQUEST TIME
                                        <span class="sort-icon">↕</span>
                                    </th>
                                    <th style="min-width: 100px;" class="ipt_tdhr" v-on:click="sortby('invoice_id')">
                                        INVOICE #
                                        <span class="sort-icon">↕</span>
                                    </th>
                                    <th style="min-width: 200px;" class="ipt_tdhr">
                                        CUSTOMER
                                    </th>
                                    <th style="min-width: 100px;" class="ipt_tdhr" v-on:click="sortby('requesting_username')">
                                        REQUESTING USER
                                        <span class="sort-icon">↕</span>
                                    </th>
                                    <th style="min-width: 200px;" class="ipt_tdhr" v-on:click="sortby('locsub')">
                                        REQUESTING STORE
                                        <span class="sort-icon">↕</span>
                                    </th>
                                    <th style="min-width: 100px;" class="ipt_tdhr" v-on:click="sortby('approved')">
                                        ACTION
                                        <span class="sort-icon">↕</span>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, idx) in items" :key="idx" class="fade-in-row" :style="{ animationDelay: `${idx * 0.03}s` }">
                                    <td class="ipt_tdr" style="">
                                        {{ item.ts }}
                                    </td>
                                    <td class="ipt_tdr" style="">
                                        {{ item.invoice_id }}
                                    </td>
                                    <td class="ipt_tdr" style="">
                                        <div class="customer-info">
                                            <strong>{{ item.customer.fullname }}</strong>
                                            <span class="customer-phone">({{ item.customer.phone }})</span>
                                        </div>
                                    </td>
                                    <td class="ipt_tdr" style="">
                                        {{ item.requesting_username }}
                                    </td>
                                    <td class="ipt_tdr" style="">
                                        {{ packet.locsubsdict[item.locsub] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        <div v-if="item.loading">
                                            <loading
                                                :active="item.loading"
                                                :can-cancel="false"
                                                :is-full-page="false"
                                                :width="20"
                                                :height="20"
                                                style="position:relative; display: inline-block;"
                                            >
                                            </loading>
                                        </div>
                                        <div v-else>
                                            <b-form-select 
                                                size="sm" 
                                                :options="refund_statuses" 
                                                v-model="item.approved"  
                                                @change="update_refund_request(item)" 
                                                :style="{'backgroundColor': get_bg_color(item), 'fontSize': '13px', 'width': '140px', 'borderRadius': '8px', 'fontWeight': '500'}" 
                                                :disabled="is_action_disabled()"
                                                class="glass-select"
                                            >
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>-- Select --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </div>
                                    </td>
                                 </tr>
                            </tbody>
                         </table>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "AdminToolsVendorOrders",
        components: {Backer, Loading, DatePicker},
        data: function() {
            return {
                packet: {},
                sort_asc: true,
                items: [],
                items_being_loaded: false,
                refund_statuses: [
                    {value: 1, text: "REQUESTED"},
                    {value: 2, text: "APPROVED"},
                    {value: 3, text: "DENIED" },
                    {value: 5, text: "CLOSE" },
                    {value: 4, text: "DELETE" },
                ],
                sort_asc: true,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Refund Requests',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "💰 Loading refund requests...",
                    "📋 Fetching invoice data...",
                    "🔄 Processing refund statuses...",
                    "✅ Updating records...",
                    "📊 Organizing refund list...",
                    "🔍 Checking pending requests..."
                ]
            }
        },
        computed: {
            currentTip() {
                return this.tips[this.currentTipIndex] || this.tips[0];
            }
        },
        methods: {
            // Loading animation methods
            startApiLoading(message = 'Loading Refund Requests') {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = 'Loading Refund Requests') {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Loading Refund Requests', 'Fetching Data', 'Processing Requests', 'Updating Status', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },
            
            is_action_disabled: function(e){
                let status = false;
                if (e){
                    e.preventDefault();
                }

                let userrole = this.packet.userDetails.userrole;
                if (['locationadmin', 'salesperson'].includes(userrole)){
                    status = true
                }
                return status
            },
            get_bg_color: function(item){
                let approved = item.approved;

                if (approved == 1){
                    return '#fff3cd'
                }
                else if (approved == 2){
                    return '#d4edda'
                }
                else if (approved == 3){
                    return '#f8d7da'
                }
                else if (approved == 5){
                    return '#d1ecf1'
                }
                else {
                    return '#e9ecef'
                }
            },
            update_refund_request: function(item){
                let that = this;
                let data = {invoice_id: item.invoice_id, approved: item.approved};
                let path = "/api/sales/update_refund_request/";
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully updated the refund request.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        if (item.approved == 4){
                            let idx = item.idx;
                            that.items = that.items.filter(function(d){return d.idx != idx});
                        }
                    }
                    item.loading = false;
                }
                let f =  function(error){
                    that.$bvToast.toast(
                        "Error updating refund request.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            update_vendor_order_wrapper: function(item){
                let that = this;
                let quantity = parseInt(item.quantity);
                if (isNaN(quantity) || quantity <= 0){
                    this.$vex.dialog.alert({
                        message: "Please provide a valid non-zero quantity for the order."
                    });
                    return
                }
                item.quantity = quantity;

                if (item.vendor_order_status != 3){
                    this.update_vendor_order(item);
                }
                else {
                    if (item.location_id){
                        this.update_vendor_order(item);
                    }
                    else {
                        if (!item.locsub){
                            this.$vex.dialog.alert({
                                message: "Please select a location where the item has to be added."
                            });
                            return
                        }
                        else {
                            let splitted = item.locsub.split("|");
                            item.location_id = parseInt(splitted[0]);
                            item.sublocation_id = parseInt(splitted[1]);

                            this.$vex.dialog.confirm({
                                message: "Setting a DELIVERED status with a location will add the given quantity of products to the inventory. Are you sure?",
                                callback: function (value) {
                                    if (value) {
                                        that.update_vendor_order(item)
                                    } else {
                                        return
                                    }
                                }
                            });
                        }
                    }
                }
            },
            update_vendor_order: function(item){
                let that = this;
                let path = "/api/sales/update_vendor_order/"
                let data = item;
                let quantity = parseInt(data.quantity);
                if (isNaN(quantity) || quantity <= 0){
                    this.$vex.dialog.alert({
                        message: "Please provide a valid non-zero quantity for the order."
                    });
                    return
                }
                data.quantity = quantity;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully updated vendor order.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f =  function(error){
                    that.$bvToast.toast(
                        "Error updating vendor order.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_init: function(){
                this.startApiLoading('Loading Refund Requests');
                let that = this;
                let data = {};
                let path = "/api/sales/get_all_invoices_with_refunds_requested/"

                if (this.packet.userDetails.properties.location_id){
                    data.location_id = data.location_id;
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result;
                        if (that.items.length === 0) {
                            that.$bvToast.toast(
                                "No refund requests found.",
                                {title: "Info", autoHideDelay: 1500, variant:"info"}
                            );
                        }
                    }
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }
                let f = function(error){
                    console.error(error);
                    that.$bvToast.toast(
                        "Error loading refund requests.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }
                this.items_being_loaded = true;
                that.items = []
                Requestor.getSyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_init();
        },
        beforeDestroy() {
            this.stopLoadingAnimation();
        }
    }
</script>

<style scoped>
    /* Glass Theme Background */
    .glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
    }

    .glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Page Entrance Animation */
    @keyframes fadeInPage {
        from {
            opacity: 0;
            transform: translateY(24px);
            filter: blur(2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
            filter: blur(0);
        }
    }

    .fade-in-page {
        animation: fadeInPage 0.7s cubic-bezier(0.2, 0.9, 0.4, 1.1);
    }

    /* Row Fade Animation */
    @keyframes fadeInRow {
        from {
            opacity: 0;
            transform: translateX(-8px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    .fade-in-row {
        opacity: 0;
        animation: fadeInRow 0.28s cubic-bezier(0.2, 0.9, 0.4, 1) forwards;
    }

    /* Glass Card */
    .glass-card {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Alert */
    .glass-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 12px !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, rgba(54, 64, 80, 0.9), rgba(54, 64, 80, 0.95)) !important;
        color: white !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        transition: all 0.2s ease !important;
        border-radius: 10px !important;
        padding: 8px 20px;
        margin-bottom: 15px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .glass-btn:hover:not(:disabled) {
        background: linear-gradient(135deg, rgba(54, 64, 80, 1), rgba(54, 64, 80, 1)) !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    }

    .glass-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    /* Glass Select */
    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(128, 128, 128, 0.3) !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        cursor: pointer;
    }

    .glass-select:focus {
        border-color: rgba(54, 64, 80, 0.5) !important;
        box-shadow: 0 0 0 2px rgba(54, 64, 80, 0.1) !important;
    }

    /* Customer Info */
    .customer-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .customer-phone {
        font-size: 12px;
        color: #64748b;
    }

    /* Sort Icon */
    .sort-icon {
        margin-left: 5px;
        font-size: 11px;
        opacity: 0.7;
    }

    /* Spinner */
    .spinner-sm {
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 2px solid rgba(255,255,255,0.3);
        border-top-color: white;
        border-radius: 50%;
        animation: spin 0.6s linear infinite;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    /* Loading Overlay Styles - FIXED HEIGHT VERSION */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        width: 400px;
        min-height: 420px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 24px;
        flex-shrink: 0;
    }

    .loading-ring {
        position: relative;
        width: 80px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 3px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 28px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 32px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 20px;
        flex-shrink: 0;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.2rem;
        margin-bottom: 6px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 5px;
        height: 5px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-6px); }
    }

    .loading-progress {
        width: 80%;
        height: 3px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin: 0 auto 20px auto;
        flex-shrink: 0;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 10px;
        flex-shrink: 0;
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tip-text {
        color: #718096;
        font-size: 0.85rem;
        animation: tipFade 0.5s ease;
        margin: 0;
        padding: 0 15px;
        line-height: 1.4;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    /* Original Styles */
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
        font-size: 13px;
        background: rgba(192, 192, 192, 0.3);
        padding: 10px;
        border-radius: 4px;
        font-weight: 600;
        cursor: pointer;
        user-select: none;
        transition: background 0.2s;
    }

    .ipt_tdhr:hover {
        background: rgba(192, 192, 192, 0.5);
    }

    .ipt_tdr {
        font-weight: normal;
        font-size: 13px;
        background: rgba(255, 255, 255, 0.7);
        padding: 10px;
        border-radius: 4px;
    }

    .input-eta {
        font-size: 11px;
        text-align: center;
        border: 0px solid gray;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .glass-btn {
            width: 100%;
        }
        
        .loading-card {
            width: 320px;
            min-height: 380px;
            padding: 30px 20px;
        }
        
        .loading-tips {
            min-height: 55px;
        }
        
        .tip-text {
            font-size: 0.75rem;
        }
        
        .ipt_tdhr, .ipt_tdr {
            font-size: 11px;
            padding: 6px;
        }
        
        .glass-select {
            width: 120px !important;
            font-size: 11px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsRefundRequests.vue